import React from 'react';
import cx from 'classnames';

import Header from 'components/common/Header';
import Footer from 'components/common/Footer';
import css from './PageLayout.module.scss';

interface Props {
  className?: string;
  contentClassName?: string;
  children?: React.ReactNode;
  isTransparentHeader?: boolean;
  isFullVideo?: boolean;
  isFullWidth?: boolean;
  isWhiteHeader?: boolean;
  isMarketingHeader?: boolean;
  showFooterCta?: boolean;
}

const PageLayout: React.FC<Props> = ({
  className = '',
  contentClassName = '',
  children = null,
  isTransparentHeader = false,
  isFullVideo = false,
  isFullWidth = false,
  isWhiteHeader = true,
  isMarketingHeader = false,
  showFooterCta = true,
}: React.ComponentProps<typeof PageLayout>) => {
  return (
    <div className={cx(css.pageLayout, className)}>
      <Header isTransparentHeader={isTransparentHeader} isWhite={isWhiteHeader} isMarketingHome={isMarketingHeader} />
      <div
        className={cx(
          css.contentWrap,
          isFullVideo ? css.fullVideo : '',
          contentClassName,
          isFullWidth ? css.fullWidth : '',
        )}
      >
        {children}
      </div>
      <Footer showCta={showFooterCta} />
    </div>
  );
};

export default PageLayout;
